import React from 'react';
import cookie from 'react-cookies';
import { useNavigate } from 'react-router-dom';

import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';

import HomeIcon from '@mui/icons-material/Home';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import AppsIcon from '@mui/icons-material/Apps';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';

const FooterMenu = (props) => {
	const auth = cookie.load('SESSION');
	const navigate = useNavigate();

	const Logout = () => {
		if (window.confirm('Er du sikker på, at du vil logge ud?')) {
			cookie.remove('SESSION', { path: '/' });
			navigate('/');
		}
	};
	const handleChange = (event, url) => {
		if (props.onboardActive) {
			if (!window.confirm('Er du sikker på, at du vil forlade onboarding?')) {
				event.preventDefault();
				return false;
			}
		}
		navigate(url);
	};

	return (
		<div style={{ position: 'fixed', bottom: '0', left: '0', backgroundColor: '#fff', width: '100%', borderTopLeftRadius: '10px', borderTopRightRadius: '10px', textAlign: 'center' }}>
			<div style={{ display: 'inline-block' }}>
				<BottomNavigation
					showLabels
					value={props.activeMenu}
				>
					<BottomNavigationAction label="Hjem" icon={<HomeIcon />} onClick={(event) => handleChange(event, '/')} />
					<BottomNavigationAction label="Scan" icon={<QrCodeScannerIcon />} onClick={(event) => handleChange(event, '/scandevice')} />
					{!auth ? null : <BottomNavigationAction label="Admin" icon={<AppsIcon />} onClick={(event) => handleChange(event, '/admin')} />}
					{!auth ? <BottomNavigationAction label="Login" icon={<LoginIcon />} onClick={(event) => handleChange(event, '/login')} /> : <BottomNavigationAction label="Logout" icon={<LogoutIcon />} onClick={Logout} />}
				</BottomNavigation>
			</div>
		</div>
	);

};
export default FooterMenu;